var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-backdrop"},[_c('div',{staticClass:"modal"},[_c('v-icon',{attrs:{"id":"spinIcon"}},[_vm._v("fas fa-circle-notch fa-spin")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54d66f2e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/LoadingModal/LoadingModal.vue
// module id = 679
// module chunks = 0